
// Plain JavaScript for toggling collapsible content
const buttons = document.querySelectorAll(".toggle-button");
const contents = document.querySelectorAll(".faq-content");

buttons.forEach((button) => {
    button.addEventListener("click", function() {

        // Close all questions first
        contents.forEach((content) => {
            content.style.maxHeight = null;
        });
        buttons.forEach((innerButton) => {
            innerButton.lastElementChild.innerHTML = "+";
        });

        // Open the clicked question
        const content = this.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + "px";
        this.lastElementChild.innerHTML = "-";
    });
});

fetch('/geo/geo.php').then(function (response) {

    // The API call was successful!
    if (response.ok) {
        return response.json();
    }

    // There was an error
    return Promise.reject(response);

}).then(function (data) {
    // This is the JSON from our response
    if (data) {
        if (!data['is-za']) {
            document.body.classList.add("not-za");

            // Get the current element
            var currentNode = document.querySelector('#za-replace');

            // Create a new element
            var newNode = document.createElement('div');

            // Add ID and content
            newNode.innerHTML = data['za-replace'];

            // Replace the current node with the new node
            currentNode.replaceWith(newNode);
        } else {
            document.body.classList.add("is-za");
        }

    }
}).catch(function (err) {
    // There was an error
    console.warn('Something went wrong.', err);
});